import dotProp from 'dot-prop-immutable'
import { connect } from 'react-redux'
import { toggleToResize } from '../../actions/project/resizable'
import { IconElement } from '../../components/FrameMenu/index'

const mapStateToProps = state => ({
  isSelected: dotProp.get(state, 'project.allowToResize', false),
})

const mapDispatchToProps = dispatch => ({
  action: () => dispatch(toggleToResize()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IconElement)



// WEBPACK FOOTER //
// ./src/containers/FrameMenu/Resize.js